import React, { useState, useEffect } from "react";
import { Modal, howDoesItWork } from "../../../../Components";


export default function ModalConfirmSpam(props) {

  useEffect(() => {

  }, [])

  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="modal__camp">
        <div className="modal__assetDetail-delete perm long">
          <h4>Mark as Spam?</h4>
          <p className="sm">
            Are you sure you want to mark this message as spam?
          </p>

          <div className="modal__assetDetail-delete-btns">
            <button className="button secondary" onClick={props.close}>
              Cancel
            </button>
            <button className="button primary" onClick={props.reportspam}>
              Spam
            </button>
          </div>
        </div>
      </div>
    </Modal>


  );
}

